// extracted by mini-css-extract-plugin
module.exports = {"listOfItems":"_2iNw0gQpWJTtx5IUfGBbMm","item":"i4lp_w27_NOnZCWwPg5gs","dot":"_3MsXIOQu2wlztoNDGVH4lm"};